/**
 * The browser entry point. The only module that touches the DOM root.
 *
 * Kept apart from `App.tsx` for the same reason `apps/api/src/start.ts` is kept apart from
 * `server.ts`: importing the application — which every test does — must never mount it.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app/App.js";
import "./styles/editorial.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("The document has no #root element to mount into.");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
